/** Helper to add fields to an object that are derived from other fields */
export function computed<T extends {}, U extends {}>(base: T, fn: (state: T) => U): T & U {
    return {
        ...base,
        ...fn(base),
    };
}

